/**
 * Wann welcher Knopf des Steppers traegt — als reine Funktionen, damit die Regel pruefbar ist.
 *
 * <h2>Ein gesperrter WERT sperrt das Entfernen nicht</h2>
 *
 * Der Stepper legt das Entfernen der ZEILE auf denselben Knopf wie das Verringern der MENGE: steht
 * der Wert auf `min`, wird aus dem Minus ein Muelleimer. Damit erbte das Entfernen bis 2026-08-26
 * den gesperrten Zustand des Mengenfeldes — und genau das wurde im Muster-Schritt des
 * HiMi-Assistenten zur Sackgasse. Ein dort dazugesuchtes Produkt, das der Lieferant nicht als
 * Muster fuehrt, wird automatisch abgewaehlt, das Formular-Schema sperrt daraufhin `anzahlMuster`,
 * und die Zeile liess sich nicht mehr loswerden (Befund Tim 2026-08-26: „ein nicht bemusterbares
 * Produkt kann auch nicht mehr entfernt werden weil die Knoepfe deaktiviert sind"). Sie stand fuer
 * immer in der Liste, ohne je als Muster rauszugehen.
 *
 * Entfernen ist eine Aktion auf der Zeile, keine Aenderung am Wert. Nur `nurLesen` nimmt beides
 * weg: eine reine Ansicht bietet ueberhaupt keine Aktion an.
 */
export interface NumberStepperZustand {
  /** Die Zeile darf ueberhaupt entfernt werden (`removable` am Bauteil). */
  removable: boolean
  /** Der Wert laesst sich nicht aendern — aus dem Formular-Schema oder weil das Feld nur lesbar ist. */
  gesperrt: boolean
  /** Nur-Lesen. Nimmt auch das Entfernen weg, anders als ein blosses `gesperrt`. */
  nurLesen: boolean
  wert: number
  min: number
  max: number | undefined
}

/**
 * Der Minus-Knopf zeigt den Muelleimer und entfernt die Zeile.
 *
 * Bei gesperrtem Wert gilt das **unabhaengig vom Wert**: ohne bedienbares Minus gaebe es keinen Weg
 * auf `min` herunter, das Entfernen bliebe also unerreichbar.
 */
export function zeigtEntfernen(z: NumberStepperZustand): boolean {
  return z.removable && !z.nurLesen && (z.gesperrt || z.wert <= z.min)
}

export function kannVerringern(z: NumberStepperZustand): boolean {
  return !z.gesperrt && z.wert > z.min
}

export function kannErhoehen(z: NumberStepperZustand): boolean {
  return !z.gesperrt && (z.max === undefined || z.wert < z.max)
}
